export const DEFAULT_TIMEZONE = 3; // Московское время
